import { render, staticRenderFns } from "./news_unit.vue?vue&type=template&id=75388d15&"
import script from "./news_unit.vue?vue&type=script&lang=js&"
export * from "./news_unit.vue?vue&type=script&lang=js&"
import style0 from "./news_unit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports